import img1 from "../../assets/Images/Accounting/Balance Sheet.png"

export default function BalanceSheet() {
    return (
        <section id="balance-sheet" className="space-y-16">

            {/* HEADER */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    7. Balance Sheet
                </h1>

                <p className="text-md text-slate-600 max-w-3xl">
                    The Balance Sheet provides a snapshot of the company’s financial
                    position by summarizing assets, liabilities, and equity on a specific
                    date.
                </p>

                <section className="bg-white border-l border-[#C9A24E] p-4 mt-4">
                    <h2 className="text-lg font-semibold mb-3">Overview</h2>
                    <p className="text-slate-600 text-sm">
                        The Balance Sheet shows what the business owns and owes, ensuring
                        that the accounting equation is balanced.
                    </p>
                </section>
            </section>

            {/* DATE FILTER */}
            <section className="">
                <div>
                    <h3 className="font-semibold mb-2">As-Of Date Selection</h3>
                    <p className="text-slate-600 mb-4">
                        Select a date to view the Balance Sheet as of that specific day.
                    </p>

                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>Date selector</li>
                        <li>Show button recalculates balances</li>
                    </ul>
                </div>

                <div className=" rounded-lg p-4 mt-4">
                    <img src={img1} alt="" />
                </div>
            </section>

            {/* EXPORT */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">Export & Print</h3>
                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Print Balance Sheet</li>
                    <li>Export to Excel</li>
                    <li>Export to PDF</li>
                </ul>
            </section>

            {/* ASSETS */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">Assets</h3>

                <p className="text-slate-600 mb-3">
                    Assets represent everything the business owns or controls.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Cash</li>
                    <li>Cheque</li>
                    <li>Online payments</li>
                    <li>Bank transfers</li>
                    <li>Total Assets calculation</li>
                </ul>
            </section>

            {/* LIABILITIES */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">Liabilities</h3>

                <p className="text-slate-600 mb-3">
                    Liabilities show what the business owes to others.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Accounts payable</li>
                    <li>Booking liabilities</li>
                    <li>Outstanding payables</li>
                    <li>Other liabilities</li>
                    <li>Total Liabilities calculation</li>
                </ul>
            </section>

            {/* EQUITY */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">Equity</h3>

                <p className="text-slate-600 mb-3">
                    Equity represents the owner’s interest in the business.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Owner’s capital</li>
                    <li>Retained earnings</li>
                    <li>Total equity</li>
                </ul>
            </section>

            {/* ACCOUNTING EQUATION */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">Accounting Equation</h3>

                <p className="font-medium text-slate-800">
                    Assets = Liabilities + Equity
                </p>

                <p className="text-slate-600 mt-3">
                    The Balance Sheet ensures this equation always remains balanced.
                </p>
            </section>

            {/* WHY IMPORTANT */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">Why Balance Sheet Matters</h3>
                <p className="text-slate-600 max-w-3xl">
                    The Balance Sheet provides financial clarity, helps assess stability,
                    supports audits, and guides long-term business planning.
                </p>
            </section>

        </section>
    );
}
